import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const DeleteChatBookmarkMutation = graphql(`
  mutation DeleteChatBookmark($id: ID!) {
    deleteChatBookmark(id: $id) {
      id
      __typename
      chatHistory {
        id
        __typename
        client {
          id
          __typename
          name
          externalReference
        }
        sessionId
        messages
        createdAt
        updatedAt
      }
      client {
        id
        __typename
        name
        externalReference
      }
      messageIndex
      title
      subtitle
      userDetailsId
      createdAt
    }
  }
`);

export function useDeleteChatBookmark() {
  const [result, deleteChatBookmarkMutation] = useMutation(DeleteChatBookmarkMutation);
  const [error, setError] = useState<Error | null>(null);

  const deleteChatBookmark = useCallback(
    async (id: string) => {
      try {
        const response = await deleteChatBookmarkMutation({ id });
        if (response.error) {
          throw response.error;
        }
        return response.data?.deleteChatBookmark;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [deleteChatBookmarkMutation],
  );

  return { deleteChatBookmark, result, error };
}
